import { Component, EventEmitter, OnInit, Output, Input, OnChanges, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CfetBaseComponent, CfetService, CfetRegExContant, PasswordMatchValidator, CfetPageNamesConstant } from '../../../cfet-core';
import { PasswordValidationTooltipComponent } from './../../../cfet-shared';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-complete-profile-utf-form',
    templateUrl: './complete-profile-utf-form.component.html',
    styleUrls: ['./complete-profile-utf-form.component.scss'],
    standalone: false
})

export class CompleteProfileUtfFormComponent extends CfetBaseComponent implements OnInit, OnChanges {
  public securityQuestionsList: any[] = [];
  timeZoneList = [];
  completeProfileFormGroup: UntypedFormGroup;
  emailAddress: UntypedFormControl;
  newPassword: UntypedFormControl;
  confirmPassword: UntypedFormControl;
  securityQuestion: UntypedFormControl;
  securityAnswer: UntypedFormControl;
  timeZone: UntypedFormControl;
  termsChecked: UntypedFormControl;
  isInvalidPassword = false;
  isWeekPassword = false;
  showPwd: boolean;
  errorFlagPArray: any = [];
  getPersonalInfo: any;
  isFocus = false;
  timeZoneValue: any = { value: '', text: 'Select' };
  SecurityQuestionvalue: any = { value: '', text: 'Select' };
  termsConditionChecked = false;
  totalHeight: number;
  questionExpanded = '';
  timezoneExpanded = '';
  checkPasswordMatch = false;
  isPasswordValid = false;
  showLoading = false;
  openTooltip = false;
  mobileView = false;
  openCancelModal = '';
  showCancelModal = false;
  getData: any;
  showInactivityModal = true;
  countDown: any;
  openInactivityModal = '';
  securityQuestions: Array<any> = [];
  timeZoneData: Array<any> = [];
  timezone = '';
  isChecked = false;
  isNewForm = false;
  @ViewChild('userActivationQTooltip') private UserActivationQTooltip;
  @Output() openTermsPage: any = new EventEmitter<any>();
  @Output() showCodeSection: any = new EventEmitter<any>();
  @ViewChild(PasswordValidationTooltipComponent) PasswordValidationTooltipComponent;
  @Input() isFocusOn: boolean;
  @Input() showWeekPassword: boolean;
  @Output() progressTrackerEvent = new EventEmitter<any>();


  constructor(public cfetService: CfetService, private cdr: ChangeDetectorRef) { super(); }

  ngOnChanges() {
    if (this.showWeekPassword) {
      this.isWeekPassword = true;
      this.errorFlagPArray[0] = true;
      this.cfetService.clearPasswordErrors();
      this.cfetService.pwdObj.currentPassword[0] = '';
      this.newPassword.setValue('');
      this.confirmPassword.setValue('');
      this.showPwd = false;
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.emailAddress = new UntypedFormControl('', [Validators.required]);
    const passwordRegEx = new RegExp(CfetRegExContant.pd_format);
    this.newPassword = new UntypedFormControl('', {
      validators:
        Validators.compose([Validators.required,
        Validators.minLength(8),
        Validators.maxLength(24),
        Validators.pattern(passwordRegEx)]),
      updateOn: 'blur'
    });
    this.confirmPassword = new UntypedFormControl('', {
      validators:
        Validators.compose([Validators.required,
        Validators.minLength(8),
        Validators.maxLength(24),
        Validators.pattern(passwordRegEx)])
    });
    this.securityQuestion = new UntypedFormControl('', [Validators.required]);
    this.securityAnswer = new UntypedFormControl('',
      { validators: [Validators.required, Validators.minLength(3)], updateOn: 'blur' });
    this.timeZone = new UntypedFormControl('', [Validators.required]);
    this.termsChecked = new UntypedFormControl('', [Validators.required]);
    this.completeProfileFormGroup = new UntypedFormGroup({
      emailAddress: this.emailAddress,
      newPassword: this.newPassword,
      confirmPassword: this.confirmPassword,
      securityQuestion: this.securityQuestion,
      securityAnswer: this.securityAnswer,
      timeZone: this.timeZone,
      termsChecked: this.termsChecked
    });
    this.completeProfileFormGroup.setValidators(PasswordMatchValidator());

    this.completeProfileFormGroup.valueChanges.subscribe(() => {
      this.validatingPassword()
    });
    const commonListValues = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.timeZoneData = commonListValues['validTimeZones'];
    if (this.timeZoneData && this.timeZoneData.length > 0) {
      this.timeZoneList = this.timeZoneData.map(t => {
        return { value: t, text: t };
      });
    }
    if (sessionStorage.getItem('returningFromPwdPage') && Object.keys(sessionStorage.getItem('returningFromPwdPage')).length !== 0) {
    const isReturning = JSON.parse(sessionStorage.getItem('returningFromPwdPage'));
    if (isReturning == true) {
      this.isNewForm = true;
    }
    else {
      this.isNewForm = false;
    }
  }
    if (!this.isNewForm && sessionStorage.getItem('profileInformation') && Object.keys(sessionStorage.getItem('profileInformation')).length !== 0) {
      sessionStorage.removeItem('profileInformation');
    }
    if (this.isNewForm && sessionStorage.getItem('profileInformation')) {
      const updatedPersonalInfo = JSON.parse(sessionStorage.getItem('profileInformation') || '{}');
      this.securityQuestion.setValue(updatedPersonalInfo.securityQuestion);
      this.SecurityQuestionvalue = { value: updatedPersonalInfo.securityQuestion, text: updatedPersonalInfo.securityQuestion };
      this.securityAnswer.setValue(updatedPersonalInfo.securityAnswer);
      this.termsChecked.setValue(false);
      this.isChecked = false;
      this.timezone = updatedPersonalInfo.timeZone;
      this.completeProfileFormGroup.get('newPassword').setValue('');
      this.completeProfileFormGroup.get('confirmPassword').setValue('');
    }
    if (sessionStorage.getItem('ngStorage-savedData') && Object.keys(sessionStorage.getItem('ngStorage-savedData')).length !== 0) {
      this.getPersonalInfo = JSON.parse(sessionStorage.getItem('ngStorage-savedData'));
      if (this.getPersonalInfo && this.getPersonalInfo.emailaddress) {
        this.emailAddress.setValue(this.getPersonalInfo.emailaddress);
        this.emailAddress.disable();
      }
    }
    sessionStorage.removeItem('returningFromPwdPage');
    this.getData = sessionStorage.getItem('fromOtpPage') ? JSON.parse(sessionStorage.getItem('fromOtpPage')) : {};
    if (this.getData && this.getData.action && this.getData.action === 'fromOtpPage') {
      this.timeZone.setValue(this.getData.timeZone);
      this.timeZoneValue = { value: this.getData.timeZone, text: this.getData.timeZone };
      this.termsConditionChecked = true;
      this.termsChecked.setValue(true);
      this.securityQuestion.setValue(this.getData.securityQuestion);
      this.SecurityQuestionvalue = { value: this.getData.securityQuestion, text: this.getData.securityQuestion };
      this.securityAnswer.setValue(this.getData.securityAnswer);
    }
    if (environment.enableUTFSessionTimeout) {
      this.checkInactivity();
    }
    this.loadSecurityQuestions();
    this.loadTimezone();
  }

  loadTimezone(){
    this.timezone = localStorage.getItem('timezone');
      //this.timezoneExpanded = '';
        this.timeZoneList.forEach(ele => {
            if (ele.value.includes(this.timezone)){
              this.timeZoneValue= ele;
              this.selectTimezone(ele);
            }
      })
    }

  validatingPassword() {
    if (this.completeProfileFormGroup.errors || this.completeProfileFormGroup.valid || this.completeProfileFormGroup.invalid) {
      if (this.newPassword.value.length > 0 && this.confirmPassword.value.length > 0 &&
        this.newPassword.value !== this.confirmPassword.value) {
        this.isInvalidPassword = true;
      } else {
        this.isInvalidPassword = false;
      }
    }
  }

  loadSecurityQuestions() {
    const profile = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.securityQuestions = profile['securityQuestions'];
    if (this.securityQuestions.length > 0 && this.securityQuestions) {
      this.securityQuestionsList = this.securityQuestions.map(
        question => {
          return { value: question, text: question };
        }
      );
    }
  }

  emitedPasswordMethodReset(event) {
    if (event) {
      if (event.pwd) {
        this.cfetService.pwdObj.isErrorCodeArray[event.index] = '';
      }
      let errorListFlag;
      this.completeProfileFormGroup.get('newPassword').setValue(event.pwd);
      errorListFlag = Object.values(event).includes(false);
      this.confirmingPassword(event);
      if (errorListFlag) {
        this.completeProfileFormGroup.get('newPassword').setErrors({
          'pattern': errorListFlag
        });
        this.errorFlagPArray[event.index] = (event.eFlag && event.eFlag[event.index]) ?
          event.eFlag[event.index] : false;
      }
      if (!this.completeProfileFormGroup.get('newPassword').value && !this.errorFlagPArray[event.index]) {
        this.completeProfileFormGroup.get('newPassword').setErrors(null);
      }
      this.isPasswordValid = (event.capitalLetterRule && event.lengthRule && event.numRule &&
        event.smallLetterRule && event.specialCharsRule && event.length24 &&
        event.repeating3 && event.sequence3) ? true : false;
    }
  }

  confirmingPassword(event) {
    if (this.confirmPassword && (event.pwd === this.confirmPassword.value)) {
      this.completeProfileFormGroup.get('confirmPassword').setErrors(null);
    } else {
      this.isWeekPassword = false;
      this.completeProfileFormGroup.get('confirmPassword').setErrors({ misMatch: true });
    }
  }

  selectQuestions(event): void {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.questionExpanded = '';
      this.completeProfileFormGroup.patchValue({
        securityQuestion: event.value
      });
    }
  }

  onClickSecurityQuestion(event) {
    if (event.target.ariaExpanded === 'true') {
      this.questionExpanded = 'dropdown-opened';
    } else {
      this.questionExpanded = '';
    }
  }

  selectTimezone(event): void {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.completeProfileFormGroup.patchValue({
        timezone: event.value
      });
    }
  }

  onClickTimeZone(event) {
    if (event.target.ariaExpanded === 'true') {
      this.timezoneExpanded = 'dropdown-opened';
      console.log("fetched timezone"+localStorage.getItem('timezone'));
    } else {
      this.timezoneExpanded = '';
    }
  }

  @HostListener('document:click', ['$event']) clickout(event) {
    if (event.target.id !== 'select_security_question' && event.target.id !== 'time_zone') {
      this.questionExpanded = '';
      this.timezoneExpanded = '';
    }
  }

  showHidePassword(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showPwd = !this.showPwd;
    }
  }

  resetField(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.confirmPassword.setValue('');
    }
  }

  tooltipSonarFix(referenceName) {
    this[referenceName].nativeElement.href = 'javascript:void(0)';
  }

  confirmCheckbox(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.isChecked = !this.isChecked;
      if (this.isChecked) {
        this.termsConditionChecked = true;
        this.termsChecked.setValue(true);
      } else {
        this.termsConditionChecked = false;
        this.termsChecked.setValue(false);
      }
    }
  }

  submit(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      const profileInfo = {
        'action': 'fromPasswordPage',
        'pwd': this.newPassword.value,
        'timeZone': this.timeZoneValue.value,
        'securityQuestion': this.SecurityQuestionvalue.value,
        'securityAnswer': this.securityAnswer.value
      };
      sessionStorage.setItem('profileInformation', JSON.stringify(profileInfo));
      this.progressTrackerEvent.emit('createPwd');
      this.showCodeSection.emit(true);
      clearInterval(this.countDown);
    }
  }

  openTerms(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.openTermsPage.emit(true);
    }
  }

  cancel(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  disabledSubmitButton() {
    if (this.emailAddress.value === '' || this.emailAddress.value === undefined ||
      this.SecurityQuestionvalue.value === '' || this.SecurityQuestionvalue.value === undefined ||
      this.securityAnswer.value === undefined || this.securityAnswer.value.length < 3 ||
      this.timeZoneValue.value === '' || this.timeZoneValue.value === undefined ||
      this.termsConditionChecked === false || !this.isPasswordValid || !this.checkPasswordMatch) {
      return true;
    } else {
      return false;
    }
  }

  changeConfirmPwd(event) {
    if (this.isPasswordValid && this.newPassword.value === this.confirmPassword.value) {
      this.checkPasswordMatch = true;
    } else {
      this.checkPasswordMatch = false;
    }
  }

  pwdKeyup(e) {
    if (e.key === 'Enter' || e.type === 'click' || e.key === 'Tab') {
      this.isFocus = true;
    }
  }

  isPasswordTooltipExpanded(event) {
    if (event !== undefined) {
      this.isFocusOn = event;
      this.openTooltip = event;
      if (window.innerWidth < 900) {
        this.mobileView = true;
      }
    }
  }

  pwdBlur() {
    this.isFocus = false;
  }

  closeCancelModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  closeInactivityModal(event) {
    if (event === 'modalClose') {
      this.openInactivityModal = 'close';
      clearInterval(this.countDown);
    }
  }

  @HostListener('window:load')
  @HostListener('document:mousemove')
  @HostListener('document:keyup')
  @HostListener('document:click')
  @HostListener('window:scroll')
  @HostListener('document:touchstart', ['$event']) onMove($event?: any) {
    if (environment.enableUTFSessionTimeout && this.openInactivityModal !== 'open') {
      clearInterval(this.countDown);
      this.checkInactivity();
    }
  }

  openCancelModalIfTimeDiffLessThan30Seconds(timeDiff) {
    if (timeDiff < 30000 && timeDiff > 0) {
      setTimeout(() => {
        this.openInactivityModal = 'open';
      });
      this.showCancelModal = false;
    }
  }

  setReturnUrlToSessionStorage() {
    let returnUrl = '';
    if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
      returnUrl = sessionStorage.getItem('returnUrl');
    }
    sessionStorage.clear();
    if (returnUrl !== '') {
      sessionStorage.setItem('returnUrl', returnUrl);
    }
  }

  checkInactivity() {
    const countDownDate = new Date().getTime() + 600000;
    this.countDown = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDiff = countDownDate - currentTime;
      this.openCancelModalIfTimeDiffLessThan30Seconds(timeDiff);
      if (timeDiff < 0) {
        clearInterval(this.countDown);
        setTimeout(() => {
          this.openInactivityModal = 'close';
        });
        this.setReturnUrlToSessionStorage();
        sessionStorage.setItem('fnStatus', 'fnStatus=eligible-pending');
        window.location.href = CfetPageNamesConstant.SESSION_TIME_OUT_UTF;
      }
      // Force the view to reflect the tick now rather than waiting on the next zone-triggered event.
      this.cdr.detectChanges();
    }, 350);
  }
}
